import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { login } from "./authAPI";

const initialState = {
  token:
    (localStorage?.auth && JSON.parse(localStorage.auth)?.token) || undefined,
  info: (localStorage?.auth && JSON.parse(localStorage.auth)) || undefined,
  status: "idle",
  errorCode: undefined,
  tokenFirstLogin: undefined,
};

export const authAsync = createAsyncThunk(
  "login/post",
  async (data, { rejectWithValue }) => {
    try {
      const response = await login(data);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const authSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = undefined;
      state.info = undefined;
      state.errorCode = undefined;
      state.tokenFirstLogin = undefined;
      localStorage.removeItem("auth");
      localStorage.removeItem("token");
      return state;
    },
    updateAuth: (state, action) => {
      state.info = action.payload;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(authAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(authAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.token = action.payload.token;
        state.info = action.payload;
        state.errorCode = undefined;
      })
      .addCase(authAsync.rejected, (state, action) => {
        state.status = "idle";
        if (
          action?.payload?.status === 403 &&
          action?.payload?.data?.message === "Permission Denied"
        ) {
          state.errorCode = action?.payload?.status;
          message.error("Không có quyền truy cập !");
          // state.tokenFirstLogin = action?.payload.data.result.accessToken;
        } else if (action?.payload?.data?.message === "Password not correct") {
          message.error("Sai tài khoản hoặc mật khẩu !");
        } else if (
          action?.payload?.status === 404 &&
          action?.payload?.data?.message === "Email not found"
        ) {
          message.error("Tài khoản không tồn tại !");
        } else {
          message.error("Đăng nhập thất bại !");
        }
      });
  },
});

export const getInfoUser = (state) => state.auth.info;
export const { logout, updateAuth } = authSlice.actions;

export default authSlice.reducer;
